import React from 'react';
import { Route, Routes } from 'react-router-dom';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

// import constants
import { PAGES, PAGE_IDS } from 'js/constants/Pages';

// import pages
import PageHome from 'js/page/Page.home';
import PageLibrary from 'js/page/Page.library';
import PageCollections from 'js/page/Page.collections';
import PageNotFound from 'js/page/Page.not_found';
import SectionMain from 'js/containers/section/Section.main';
import PageCards from 'js/page/Page.cards';
import PageShare from 'js/page/Page.share';

// ---
// import page stacks
// ---

// card stack
import PageCard from 'js/page/Page.card';
import CardIndex from 'js/containers/stack/card/Card.Index';
import CardFullView from 'js/containers/stack/card/Card.full-view';

// find (search page) stack
import PageFind from 'js/page/Page.find';
import FindIndex from 'js/containers/stack/find/Find.index';
import FindResults from 'js/containers/stack/find/Find.results';

// collection stack
import CollectionIndex from 'js/containers/stack/collection/Collection.Index';
import CollectionViewCollection from '../stack/collection/Collection.view-collection';

const Router = () => {
  const { location, state: { backgroundLocation = false } = {} } = useRouteInfo(true);

  return (
    <SectionMain>
      <Routes location={backgroundLocation || location} key={(backgroundLocation || location).pathname}>
        <Route
          path={PAGES[PAGE_IDS.library].base_url}
          element={<PageLibrary path={PAGES[PAGE_IDS.library].base_url} />}
        />
        <Route path={PAGES[PAGE_IDS.find].base_url} element={<PageFind path={PAGES[PAGE_IDS.find].base_url} />}>
          <Route index element={<FindIndex />} />
          <Route path={PAGES[PAGE_IDS.find].stack[PAGE_IDS.results].stack_url} element={<FindResults />} />
        </Route>
        {['FAVORITES', 'RECENT', 'ALL'].map((type) => (
          <Route
            key={type}
            path={PAGES[PAGE_IDS[type.toLowerCase()]].base_url}
            element={<PageCards type={type} path={PAGES[PAGE_IDS[type.toLowerCase()]].base_url} />}
          />
        ))}

        <Route path={PAGES[PAGE_IDS.home].base_url} element={<PageHome path={PAGES[PAGE_IDS.home].base_url} />} />
        <Route path={'/share'} element={<PageShare path={'/share'} />} />

        <Route path="/card" element={<PageCard />}>
          <Route index element={<CardIndex />} />
          <Route path=":cardId" element={<CardFullView path="/card/:cardId" />} />
        </Route>

        <Route path={PAGES[PAGE_IDS.collections].base_url} element={<PageCollections />}>
          <Route index element={<CollectionIndex />} />
          <Route
            path=":collectionId"
            element={<CollectionViewCollection path={`${PAGES[PAGE_IDS.collections].base_url}/:collectionId`} />}
          />
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </SectionMain>
  );
};

export default Router;
